import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c75","margin-right":"5px"} }, "*", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_miezz_form = _resolveComponent("miezz-form")!

  return (_openBlock(), _createBlock(_component_miezz_form, {
    ref: "ruleForm",
    modelValue: _ctx.form,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form) = $event))
  }, {
    "form-item": _withCtx(({ item }) => [
      (item.Prop == 'Name')
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            prop: item.Prop,
            label: item.Label
          }, {
            default: _withCtx(() => [
              _createVNode(_component_miezz_input, {
                modelValue: _ctx.form.Data.Name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Data.Name) = $event)),
                placeholder: '请填写'
              }, null, 8, ["modelValue"])
            ]),
            _: 2
          }, 1032, ["prop", "label"]))
        : _createCommentVNode("", true),
      (item.Prop == 'ProductSpecElementItems')
        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
            label: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("span", null, _toDisplayString(item.Label), 1)
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.ProductSpecElementItems, (p, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  style: {"width":"25% !important","margin-bottom":"15px"},
                  key: index
                }, [
                  _createVNode(_component_el_form_item, {
                    style: {"padding":"0px","margin":"0px","width":"100% !important"},
                    prop: `ProductSpecElementItems[${index}].Name`,
                    rules: _ctx.form.Rules.ProductSpecElementItems_Name
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_miezz_input, {
                        style: {"float":"right","width":"99%  !important","margin-left":"2px"},
                        class: "inputDelete",
                        modelValue: p.Name,
                        "onUpdate:modelValue": ($event: any) => ((p.Name) = $event),
                        placeholder: '请填写'
                      }, {
                        suffix: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            style: {"cursor":"pointer","font-size":"12px"},
                            onClick: ($event: any) => (_ctx.onDeleteElement(index))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Close)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["prop", "rules"])
                ]))
              }), 128)),
              _createElementVNode("span", {
                style: {"cursor":"pointer","width":"15% !important","padding-left":"10px","margin-bottom":"15px","overflow":"hidden"},
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onAddElement()))
              }, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Plus)
                  ]),
                  _: 1
                }),
                _createTextVNode(" 添加")
              ])
            ]),
            _: 2
          }, 1024))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}